import { applyContext, fetchObject } from 'helpers';
import { FiltersQueries } from 'helpers/src/graphql/queries';
import { ReflexResponse } from 'types';
import { GQL } from 'types/src/routes';

export interface fetchFiltersProps {
  marketIsActive?: boolean;
}

export const fetchFilters = async (
  data: fetchFiltersProps,
  query = FiltersQueries.default,
): Promise<ReflexResponse> =>
  await fetchObject({
    route: applyContext(GQL, 'FILTERS_QUERY'),
    query,
    data,
    returnKey: 'filterOptions',
  });
